// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"862557dd","213":"adfe1aeb","239":"618fc14e","455":"0fd48aaf","557":"725bb353"}[chunkId] + ".chunk.js";
};